import React from 'react'
import './svg-style.scss'
import { useRef } from "react";

const SvgFullscreen =()=>{
    const SvgFillRef = useRef(null);
    const white='#fff'
    const mainColor="#6FEDD6"
    const toggleFullScreen = ()=>{
        var isInFullScreen = (document.fullscreenElement && document.fullscreenElement !== null) ||
            (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
            (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
            (document.msFullscreenElement && document.msFullscreenElement !== null);

        var docElm = document.documentElement;
        if (!isInFullScreen) {
            SvgFillRef.current.style.fill = mainColor
            if (docElm.requestFullscreen) {
                docElm.requestFullscreen();
            } else if (docElm.mozRequestFullScreen) {
                docElm.mozRequestFullScreen();
            } else if (docElm.webkitRequestFullScreen) {
                docElm.webkitRequestFullScreen();
            } else if (docElm.msRequestFullscreen) {
                docElm.msRequestFullscreen();
            }
        } else {
            SvgFillRef.current.style.fill = white
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }

    }
    
    return (
        <>
            <div className='svg-fullscreen' onClick={toggleFullScreen}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path
                        fill='#fff'
                        ref={SvgFillRef}
                        className='fullScreen_icon'
                        d="M1.875 1.875L7.5 7.44375M1.875 1.875V6.9375M1.875 1.875H6.9375M1.875 22.0688L7.5 16.5M22.125 22.0688L16.5562 16.5M22.0688 1.875L16.5 7.44375M17.0625 1.875H22.125V6.9375M22.125 17.0625V22.125H17.0625M6.9375 22.125H1.875V17.0625">
                    </path>
                    </g>
                </svg>
            </div>
        </>
    )
}

export default SvgFullscreen